import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DrawerComponent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import classNames from 'classnames';
import { DataValueMap } from 'Helpers/Testing';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';

const TRANSITION_DURATION = 300;

const useStyles = buildUseStyles('Template', ((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paper: {
    width: 'unset',
    height: '100%',
    backgroundColor: theme.palette.facet.lightGray,
  },
  paddedPaper: {
    padding: theme.spacing(2),
  },
})));

const Takeover = ({
  Layout,
  metaOverrideSet,
  test,
  padding,
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const {
    modalCollection,
    modalResource,
    clearModalCollection,
    actionsRef,
    titleRef,
  } = useModalContext();

  const handleClose = () => {
    setOpen(false);
    // In order to actually see the close animation we need the `open` prop on the Mui Dialog to go from true -> false
    // and allow time for the animation to complete before clearing the modal collection and thus unmounting the component.
    setTimeout(() => {
      clearModalCollection();
    }, TRANSITION_DURATION);
  };

  useEffect(() => {
    // For the slide-in animation to work properly the Mui Drawer the `open` prop must go from true -> false.
    // We can achieve this using a state value which we initialize as false and then set to true as soon as
    // we have a valid modalCollection.
    if (modalCollection) {
      setOpen(true);
    }
  }, [modalCollection]);

  return (
    <DrawerComponent
      anchor={'bottom'}
      onClose={() => {
        clearModalCollection();
      }}
      variant={'temporary'}
      open={open}
      test={test}
      PaperProps={{
        className: classNames(classes.paper, { [classes.paddedPaper]: padding }),
      }}
      transitionDuration={TRANSITION_DURATION}
    >
      <div
        className={classes.header}
      >
        <IconButton
          onClick={handleClose}
          color={'inherit'}
          icon={CloseIcon}
          title={'Close'}
          {...DataValueMap.init('drawer-close').build()}
        />
      </div>
      <div className={classes.title} ref={titleRef} />
      <MetaResourceRenderer
        key={modalCollection.link('self').url()}
        resource={modalResource}
        layout={Layout}
        metaOverrideSet={metaOverrideSet}
      />
      <div className={classes.actions} ref={actionsRef} />
    </DrawerComponent>
  );
};

Takeover.defaultProps = {
  padding: true,
};

Takeover.propTypes = {
  Layout: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
  test: PropTypes.string.isRequired,
  padding: PropTypes.bool,
};

export default Takeover;
